import {getMethod, postMethod, putMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/ownExtraServicePriceLists', request)
}

async function post(request) {
    return await postMethod('/api/ownExtraServicePriceLists', request)
}

async function put(request) {
    return await putMethod('/api/ownExtraServicePriceLists', request)
}

export {get, post, put}
